import styled from 'styled-components';

export const BoardingPointWrap = styled.section`
  padding: 2rem;
  width: 49%;
  background: white;
  border-radius: 0.4rem;
`;
export const CardHdr = styled.p`
  font-size: 1.4rem;
  color: black;
  margin-bottom: 1.3rem;
`;
export const DateTag = styled.p`  
  background: #2276E3;
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: bold;
  color: #fff;
  padding: 0.4rem 0.6rem 0.3rem;
  margin-bottom: 1.6rem;
  display: inline-flex;
  border-radius: 0.2rem
`;
export const LocationPoint = styled.p(
  props => `
    font-size: 2.2rem;
    color: black;
    font-weight: bold;
    font-family:${props.theme.font.fontFamily};
    margin-bottom: 1.8rem
`,
);
export const CardContent = styled.p`
  color: #777777;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.2rem;
  margin-bottom: 1.4rem;
`;
export const CardLink = styled.a`
  font-size: 1.2rem;
  color: #2276E3;
`;
